import * as tslib_1 from "tslib";
import { AfterViewChecked, ElementRef, EventEmitter, OnChanges, OnInit, SimpleChanges, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { SharedModalService } from "@app/shared-modal/service/shared-modal.service";
import * as moment from "moment";
import { AuthService } from "@app/core";
import { CsDropDownService } from "@app/shared/cs-components/cs-drop-down/cs-drop-down.service";
import { CsIconClasses, CsImages } from "@app/shared/cs-components/cs-images.";
import { CsActivityLogFilterConfigService } from "@app/shared/cs-activity-log/cs-activity-log-filter-config.service";
import { PropertyViewService } from "@app/features/customers/customer/property-view/service/property-view.service";
import { AddOpportunityService } from "@app/features/customers/add-opportunity/service/add-opportunity.service";
import { ScheduledActivityService } from "@app/features/scheduled-activities/services/scheduled-activities.service";
import { CsToastBoxService } from "@app/services";
import { CsActivityLogApiService } from "@app/shared/cs-activity-log/cs-activity-log-api.service";
import { CsActivityLogEventService } from "@app/shared/cs-activity-log/cs-activity-log-event.service";
import { DatePipe } from "@app/pipes";
import { TimelineDatePipe } from "@app/pipes/timeline-date.pipe";
var MyScheduledActivitiesComponent = /** @class */ (function () {
    function MyScheduledActivitiesComponent(router, activateRoute, ajsState, sharedModalService, authService, csDropDownService, dropdownConfig, propertyService, confirmationBoxHelper, opportunityService, scheduledActivityListService, ajsScope, toast, _api, _alEvent, shortDate, timelineDateTime) {
        this.router = router;
        this.activateRoute = activateRoute;
        this.ajsState = ajsState;
        this.sharedModalService = sharedModalService;
        this.authService = authService;
        this.csDropDownService = csDropDownService;
        this.dropdownConfig = dropdownConfig;
        this.propertyService = propertyService;
        this.confirmationBoxHelper = confirmationBoxHelper;
        this.opportunityService = opportunityService;
        this.scheduledActivityListService = scheduledActivityListService;
        this.ajsScope = ajsScope;
        this.toast = toast;
        this._api = _api;
        this._alEvent = _alEvent;
        this.shortDate = shortDate;
        this.timelineDateTime = timelineDateTime;
        this.onClose = new EventEmitter();
        this.selectedTab = 'myActivity';
        this.activities = [];
        this.param = {
            'currentPage': 1,
            'pageLimit': 10,
            'selectedTab': 'myActivity',
            'date': "",
            'order': 'DESC',
            'searchText': "",
            'field': 'dateToShow',
            // 'type':'1,3,4,5',
            'recordType': '',
            'currentUser': this.userId
        };
        this.loading = true;
        this.customerType = 'customer';
        this.usersList = [];
        this.isLoadingMore = false;
        this.selectedToMail = '';
        this.scheduled = true;
        this.showCallLogModal = false;
        this.showOpportunityCallLogModal = false;
        this.showActivityModal = false;
        this.checkTodayActivity = false;
        this.todayEmailActivity = null;
        this.isCommonRoute = false;
        this.activityEdit = false;
        this.listActivity = [
            {
                "id": 1,
                "name": "Call",
                "description": null
            },
            {
                "id": 2,
                "name": "Email",
                "description": null
            },
            {
                "id": 3,
                "name": "Meeting",
                "description": null
            },
            {
                "id": 4,
                "name": "Task",
                "description": null
            }
        ];
        this.recordType = [
            { 'id': '', text: "All" },
            { 'id': 'customer', text: "Customer", feature: 'Customer' },
            { 'id': 'opportunity', text: "Opportunity", feature: 'Opportunity' },
            { 'id': 'contract', text: 'Contract', feature: 'Contract' }
        ];
        this.subscriptions = {};
        this.showUndoMessage = false;
        this.oldSearchValue = '';
        this.assignedCount = 0;
        this.unassignedCount = 0;
        /** Tab label/tooltip use translation keys (translate pipe in template). */
        this.tabs = [
            { id: 'myActivity', labelKey: 'My activities', tooltipKey: 'Assigned activities' },
            { id: 'unassignedActivity', labelKey: 'Unassigned activities', tooltipKey: 'Unassigned activities' }
        ];
        /** Scroll position per tab so each tab keeps its own scroll (not combined). */
        this.tabScrollTops = {};
        /** Cached list data per tab so tab switch does not call APIs. */
        this.tabCache = {};
        /** Master tag list (lazy-loaded once) and the "#" dropdown's currently matching subset. */
        this.hashtags = [];
        this.filteredTags = [];
        /** Tags selected as search chips (applied as the `tagIds` filter). */
        this.selectedTagFilters = [];
        this.showTagDropdown = false;
        this.hashtagsLoaded = false;
        this.activeIndex = -1;
        this.hoveredIndex = -1;
        this.pointerInside = false;
        this.isKeyboardMode = true;
        this.isDropdownOpen = false;
        this.hasMoreData = true;
        this.scrollHeightBeforeLoadMore = 0;
        this.callRestrictValue = false;
        this.hasScrollbar = false;
        /** Threshold in pixels from bottom to trigger load more (avoids subpixel/rounding issues) */
        this.scrollLoadThreshold = 50;
    }
    MyScheduledActivitiesComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.usersWritePermission = this.authService.permitted(['SetupJobUsers.writeaccess']) === true;
        this.usersUpdatePermission = this.authService.permitted(['SetupJobUsers.updateaccess']) === true;
        this.scheduledActivityUpdateAccess = this.authService.permitted(['ScheduleActivity.updateaccess']) === true;
        this.scheduledActivityWriteAccess = this.authService.permitted(['ScheduleActivity.writeaccess']) === true;
        var EmailAccess = this.authService.permitted(['SendEmail.writeaccess']) === true;
        var SMSAccess = this.authService.permitted(['SendSMS.writeaccess']) === true;
        if (EmailAccess || SMSAccess) {
            this.opportunityCommunicationAccess = true;
        }
        var JobsTabPermission = this.authService.permitted(['JobDashboard.readaccess']) === true;
        if (JobsTabPermission) {
            this.recordType.push({ 'id': 'job', 'text': "Job", 'feature': 'JobDashboard' });
        }
        this.param['selectedTab'] = 'myActivity';
        this.opportunityService.getListActivityType().subscribe(function (data) {
            var types = data.activityTypes.map(function (a) { return a.id; });
            _this.param.type = types.join(',');
            _this.scheduledActivityListService.getScheduleActivitySortPreference().subscribe(function (pref) {
                _this.setListSortParams(pref);
                if (_this.showScheduledModal === true) {
                    _this.onTabSelect('first');
                }
            }, function () {
                _this.setListSortParams(null);
                if (_this.showScheduledModal === true) {
                    _this.onTabSelect('first');
                }
            });
        });
        this.opportunityService.getAssignee().subscribe(function (data) {
            _this.assigneeList = data;
        });
        this.subscriptions['reschedule'] = this.opportunityService.$opportunityNewSchedule.subscribe(function (data) {
            if (data) {
                _this.editActivityData = 'reschedule';
                _this.validateModalStatus('activity');
            }
        });
    };
    MyScheduledActivitiesComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (!changes['showScheduledModal'] || this.showScheduledModal !== true) {
            return;
        }
        if (changes['showScheduledModal'].firstChange) {
            return;
        }
        this.selectedTab = 'myActivity';
        this.param['searchText'] = '';
        this.selectedTagFilters = [];
        this.showTagDropdown = false;
        this.filteredTags = [];
        this.scheduledActivityListService.getScheduleActivitySortPreference().subscribe(function (pref) {
            _this.setListSortParams(pref);
            _this.onTabSelect('first');
        }, function () {
            _this.setListSortParams(null);
            _this.onTabSelect('first');
        });
    };
    MyScheduledActivitiesComponent.prototype.ngAfterViewInit = function () {
        this.checkScroll();
    };
    MyScheduledActivitiesComponent.prototype.ngAfterViewChecked = function () {
        if (this.callLogWrapperRef && this.callLogWrapperRef.nativeElement &&
            this.callLogWrapperRef.nativeElement.parentElement !== document.body) {
            document.body.appendChild(this.callLogWrapperRef.nativeElement);
        }
        if (this.oppCallLogWrapperRef && this.oppCallLogWrapperRef.nativeElement &&
            this.oppCallLogWrapperRef.nativeElement.parentElement !== document.body) {
            document.body.appendChild(this.oppCallLogWrapperRef.nativeElement);
        }
    };
    MyScheduledActivitiesComponent.prototype.onResize = function () {
        this.checkScroll();
    };
    MyScheduledActivitiesComponent.prototype.checkScroll = function () {
        var el = this.activitiesScroll.nativeElement;
        var hasScroll = el.scrollHeight > el.clientHeight;
        this.hasScrollbar = hasScroll;
        if (!hasScroll) {
            el.classList.add('no-scroll');
        }
        else {
            el.classList.remove('no-scroll');
        }
    };
    MyScheduledActivitiesComponent.prototype.onListScreenClicks = function () {
        this.onClose.emit(false);
        this.router.navigateByUrl('/scheduled_activities');
    };
    MyScheduledActivitiesComponent.prototype.getTabCount = function (tabId) {
        return tabId === 'myActivity' ? this.assignedCount : this.unassignedCount;
    };
    /** Switch tab: save current scroll for this tab. If tab has cached data, use it (no API). Otherwise load from API. */
    MyScheduledActivitiesComponent.prototype.selectTab = function (tabId) {
        var _this = this;
        if (this.callRestrictValue || this.selectedTab === tabId)
            return;
        var el = this.activitiesScroll && this.activitiesScroll.nativeElement;
        if (el)
            this.tabScrollTops[this.selectedTab] = el.scrollTop;
        this.selectedTab = tabId;
        this.onTabSelect('tabChanged');
        var cached = this.tabCache[tabId];
        if (cached) {
            this.param['selectedTab'] = tabId;
            this.param['currentPage'] = cached.currentPage;
            this.hasMoreData = cached.hasMoreData;
            this.activities = cached.activities;
            this.loading = false;
            this.isLoadingMore = false;
            setTimeout(function () {
                _this.checkScroll();
                var scrollEl = _this.activitiesScroll && _this.activitiesScroll.nativeElement;
                if (scrollEl) {
                    var saved_1 = _this.tabScrollTops[tabId];
                    if (saved_1 != null)
                        requestAnimationFrame(function () { scrollEl.scrollTop = saved_1; });
                }
            }, 0);
            return;
        }
        // this.onTabSelect('tabChanged');
    };
    /** Saved sort from UserColumnPreferences (`schedule_activity_sort`), or list defaults. */
    MyScheduledActivitiesComponent.prototype.setListSortParams = function (pref) {
        if (pref && pref.field && pref.order) {
            this.param.field = pref.field;
            this.param.order = pref.order;
        }
        else {
            this.param.field = 'dateToShow';
            this.param.order = 'DESC';
        }
    };
    MyScheduledActivitiesComponent.prototype.onTabSelect = function (value) {
        var _this = this;
        this.param['selectedTab'] = this.selectedTab;
        if (value == 'first' || value == 'tabChanged') {
            this.param['currentPage'] = 1;
            this.hasMoreData = true;
            this.param['searchText'] = (value === 'tabChanged') ? '' : this.param['searchText'];
            if (value === 'tabChanged')
                this.selectedTagFilters = [];
            if (value === 'first')
                delete this.tabCache[this.selectedTab];
        }
        this.param['currentUser'] = this.userId;
        this.param['tagIds'] = this.selectedTagFilters.map(function (tag) { return tag.id; }).join(',');
        this.loading = true;
        this.callRestrictValue = true;
        var requestedForTab = this.selectedTab;
        var requestedPage = this.param.currentPage;
        this.sharedModalService.getFilterDatas(this.param).subscribe(function (response) {
            if (_this.selectedTab !== requestedForTab)
                return;
            if (response.hasOwnProperty('scheduledActivities')) {
                if (requestedPage === 1) {
                    _this.activities = response.scheduledActivities; // Replace the list for the first page
                }
                else {
                    _this.activities = _this.activities.concat(response.scheduledActivities); // Append new data
                }
                // this.unassignedCount = response.unassignedCount;
                // this.assignedCount = response.assignedCount;
                _this.usersList = response.usersList;
                _this.activities.forEach(function (item) {
                    item.teamMembersConfig = _this.parseUserDetails(item.assignees);
                    item.isAssignJobToLoggedInUser = _this.checkCanAssignJobToLogedinUser(item.assignees);
                    item.showDropdown = false;
                });
                _this.hasMoreData = response.scheduledActivities.length >= 10;
            }
            _this.tabCache[requestedForTab] = {
                activities: _this.activities.slice(),
                currentPage: requestedPage,
                hasMoreData: _this.hasMoreData
            };
            _this.loading = false;
            _this.isLoadingMore = false;
            _this.callRestrictValue = false;
            setTimeout(function () {
                _this.checkScroll();
                var el = _this.activitiesScroll && _this.activitiesScroll.nativeElement;
                if (el) {
                    if (requestedPage > 1 && _this.scrollHeightBeforeLoadMore > 0) {
                        requestAnimationFrame(function () {
                            el.scrollTop = _this.scrollHeightBeforeLoadMore;
                            _this.scrollHeightBeforeLoadMore = 0;
                        });
                    }
                    else {
                        var saved_2 = _this.tabScrollTops[_this.selectedTab];
                        if (saved_2 != null) {
                            requestAnimationFrame(function () { el.scrollTop = saved_2; });
                        }
                    }
                }
            }, 0);
        });
        this.scheduledActivityListService.getScheduledActivitiesCount('myActivity').subscribe(function (data) {
            _this.assignedCount = data.assignedCount;
            _this.unassignedCount = data.unassignedCount;
        });
    };
    MyScheduledActivitiesComponent.prototype.onScroll = function (event) {
        var element = event.target;
        this.tabScrollTops[this.selectedTab] = element.scrollTop;
        if (this.isNearBottom(element)) {
            this.loadMoreData();
        }
    };
    /** Called on touchend so load-more works when user scrolls to bottom on touch devices */
    MyScheduledActivitiesComponent.prototype.onTouchEnd = function () {
        var el = this.activitiesScroll && this.activitiesScroll.nativeElement;
        if (el && this.isNearBottom(el)) {
            this.loadMoreData();
        }
    };
    MyScheduledActivitiesComponent.prototype.isNearBottom = function (element) {
        if (!element || !element.scrollHeight)
            return false;
        var distanceFromBottom = element.scrollHeight - element.scrollTop - element.clientHeight;
        return distanceFromBottom <= this.scrollLoadThreshold;
    };
    MyScheduledActivitiesComponent.prototype.loadMoreData = function () {
        if (this.isLoadingMore || !this.hasMoreData)
            return;
        var tabTotal = this.getTabCount(this.selectedTab);
        if (this.activities.length >= tabTotal)
            return;
        if (this.activitiesScroll && this.activitiesScroll.nativeElement) {
            this.scrollHeightBeforeLoadMore = this.activitiesScroll.nativeElement.scrollHeight;
        }
        this.isLoadingMore = true;
        this.param.currentPage += 1;
        this.onTabSelect('next');
    };
    MyScheduledActivitiesComponent.prototype.ModifyActivityDate = function (date) {
        var mDate = moment(date);
        var today = moment().startOf('day');
        var endOfWeek = moment().endOf('week');
        var endOfNextWeek = moment().endOf('week').add(1, 'week');
        var shortDate = this.shortDate.transform(date);
        var cDate = moment.utc(date);
        var currentTime = this.timelineDateTime.transform(cDate, 'datetime');
        var currentHourTime = currentTime.match(/\(([^)]+)\)/);
        var tooltipDate = shortDate + " (" + currentHourTime[1] + ")";
        var label = '';
        // Past dates (including yesterday)
        if (mDate.isBefore(today, 'day')) {
            label = 'Overdue';
        }
        // Today
        else if (mDate.isSame(today, 'day')) {
            label = 'Due today';
        }
        // Tomorrow
        else if (mDate.isSame(today.clone().add(1, 'day'), 'day')) {
            label = 'Due tomorrow';
        }
        // This week (excluding today/tomorrow)
        else if (mDate.isSame(today, 'week')) {
            label = "Due " + mDate.format('dddd'); // e.g., "Due Friday"
        }
        // Next week
        else if (mDate.isAfter(endOfWeek) && mDate.isSameOrBefore(endOfNextWeek, 'day')) {
            label = 'Due next week';
        }
        // Beyond next week
        else {
            label = "Due " + mDate.format('Do MMM YYYY');
        }
        return {
            label: label,
            tooltip: tooltipDate
        };
    };
    MyScheduledActivitiesComponent.prototype.checkCanAssignJobToLogedinUser = function (assignees) {
        var _this = this;
        var userHasAccess = this.usersList.find(function (allow) { return String(allow.id) === String(_this.userId); });
        if (userHasAccess) {
            // const getSelectedMembers = this.csDropDownService.getItemsBy(this.teamMembersConfig, 'SELECTED');
            var userHasAssigned = assignees.find(function (user) { return String(user.id) === String(_this.userId); });
            if (userHasAssigned) {
                return false;
            }
            else {
                return true;
            }
        }
    };
    MyScheduledActivitiesComponent.prototype.takeThisJob = function (Record) {
        var _this = this;
        var user = { id: this.userId };
        this.selectedTeamMember(user, Record);
        this.unassignedCount--;
        this.assignedCount++;
        this.activities.forEach(function (item) {
            item.teamMembersConfig = _this.parseUserDetails(item.assignees);
            item.isAssignJobToLoggedInUser = _this.checkCanAssignJobToLogedinUser(item.assignees);
        });
        setTimeout(function () {
            _this.activities = _this.activities.filter(function (item) { return item.activityId !== Record.activityId; });
        }, 3000);
    };
    MyScheduledActivitiesComponent.prototype.selectedTeamMember = function (item, activity) {
        this.toggleAssignee(item.id, activity.activityId);
        if (item.id == this.userId && item.isSelected == false || (this.selectedTab == 'unassignedActivity')) {
            this.onTabSelect('first');
        }
    };
    MyScheduledActivitiesComponent.prototype.toggleAssignee = function (userId, activityId) {
        var _this = this;
        var activityConstant = { Call: 1, Email: 3, Meeting: 4, Task: 5 };
        this.activities = this.activities.map(function (activity) {
            if (String(activity.activityId) === String(activityId)) {
                var existsInActivity = activity.assignees.some(function (a) { return String(a.id) === String(userId); });
                var updatedActivity = void 0;
                if (existsInActivity) {
                    // ✅ Remove user if exists
                    updatedActivity = tslib_1.__assign({}, activity, { assignees: activity.assignees.filter(function (a) { return String(a.id) !== String(userId); }) });
                    var payload = {
                        assigneeIds: [],
                        deletedAssigneeIds: [Number(userId)],
                        notes: updatedActivity.notes,
                        description: updatedActivity.description,
                        activityType: activityConstant[updatedActivity.activityType],
                        scheduled_date: updatedActivity.timeToShow,
                        scheduleId: updatedActivity.activityId,
                        activityUpdate: false
                    };
                    _this.propertyService.saveEditScheduledActivity(payload, payload['scheduleId']).subscribe(function (value) {
                    });
                }
                else {
                    // ✅ Add user if not exists (from master user list)
                    var userToAdd = _this.usersList.find(function (u) { return String(u.id) === String(userId); });
                    if (userToAdd) {
                        updatedActivity = tslib_1.__assign({}, activity, { assignees: activity.assignees.concat([userToAdd]) });
                        var payload = {
                            assigneeIds: [Number(userId)],
                            deletedAssigneeIds: [],
                            notes: updatedActivity.notes,
                            description: updatedActivity.description,
                            activityType: activityConstant[updatedActivity.activityType],
                            scheduled_date: updatedActivity.timeToShow,
                            scheduleId: updatedActivity.activityId,
                            activityUpdate: false,
                        };
                        _this.propertyService.saveEditScheduledActivity(payload, payload['scheduleId']).subscribe(function (value) {
                        });
                    }
                }
                return updatedActivity;
            }
            return activity;
        });
    };
    MyScheduledActivitiesComponent.prototype.parseUserDetails = function (users) {
        var selectedUsers = users.map(function (user) { return String(user.id); });
        var config = this.formatDropDownConfig(this.usersList, 'user', selectedUsers, true);
        this.teamMembersConfig = config;
        return this.teamMembersConfig;
    };
    MyScheduledActivitiesComponent.prototype.formatDropDownConfig = function (configData, screenType, selectedId, checkIsSelected) {
        var _this = this;
        var textKey = 'name';
        var placement = 'left';
        var customRender = '';
        var isMultiChoice = false;
        var defaultData = {
            'text': '',
            'background': ''
        };
        if (screenType == 'team') {
            textKey = 'teamName';
        }
        else if (screenType == 'user') {
            textKey = 'username';
            placement = '';
            isMultiChoice = true;
            customRender = this.dropDownCustomRenderCheckbox;
        }
        if (configData && configData.length) {
            var listData_1 = [];
            configData.forEach(function (data) {
                var selected;
                if (selectedId && checkIsSelected) {
                    selected = selectedId.findIndex(function (x) { return x == data.id; });
                    if (selected === -1) {
                        selected = false;
                    }
                    else {
                        selected = true;
                        defaultData.text = data[textKey];
                        defaultData.background = data['color'];
                    }
                }
                else {
                    selected = false;
                }
                listData_1.push({
                    id: data.id,
                    isSelected: selected,
                    templateData: {
                        text: data[textKey] ? data[textKey] : '',
                        background: data['color'] ? data['color'] : '',
                        iconsList: screenType == 'user' ? _this.getIconConfiguration(data.profilepicture) : ''
                    }
                });
            });
            if (checkIsSelected) {
                return this.getCommonConfig(listData_1, defaultData, customRender, placement, isMultiChoice);
            }
            else {
                return listData_1;
            }
        }
    };
    MyScheduledActivitiesComponent.prototype.getIconConfiguration = function (profilePic) {
        return [
            this.dropdownConfig.getIconConfig('check_box', CsIconClasses.squareCheckBox, false, 'CLASS_ICON'),
            this.dropdownConfig.getIconConfig('profile_pic', profilePic || CsImages.userProfile, false, 'IMAGE', 'CIRCLE')
        ];
    };
    MyScheduledActivitiesComponent.prototype.getCommonConfig = function (listData, defaultData, customTemplate, placement, isMultiChoice) {
        if (customTemplate === void 0) { customTemplate = ''; }
        return {
            id: 'dropdown_config',
            ddTogglerConfig: {
                templateType: 'CUSTOM',
                customTemplateRef: customTemplate ? customTemplate : this.dropDownCustomRender,
                ddPlacement: placement,
                templateData: {
                    text: defaultData.text ? defaultData.text : '',
                    background: defaultData.background ? defaultData.background : ''
                }
            },
            ddMenuConfig: {
                isSearchBar: true,
                isMultiChoice: isMultiChoice,
                templateType: 'BASIC',
                items: listData,
                customStyle: { right: '-8px' },
            }
        };
    };
    MyScheduledActivitiesComponent.prototype.onRowSelect = function (data, event, selectedMail) {
        var _this = this;
        if (selectedMail === void 0) { selectedMail = null; }
        this.activities = this.activities.map(function (activity) {
            if (String(activity.activityId) === String(data.activityId)) {
                return tslib_1.__assign({}, activity, { isSelected: true });
            }
            return activity;
        });
        if (this.scheduledActivityUpdateAccess) {
            if (data.recordType !== 'Opportunity' || (data.recordType === 'Opportunity')) {
                this.onSelectCheckbox({ data: data, isChecked: event.target.checked, selectedMail: selectedMail });
            }
        }
        else {
            this.onSelectEmail({ data: data, isChecked: event.target.checked, activityId: data.activityId, activityType: false, selectedMail: selectedMail });
        }
        setTimeout(function () {
            _this.onTabSelect('first');
        }, 1000);
    };
    MyScheduledActivitiesComponent.prototype.onSelectEmail = function (event) {
        var _this = this;
        var data = event.data;
        data.checked = event.isChecked;
        var activityType = data.activityType;
        this.selectedActivity = data;
        this.selectedToMail = (event.hasOwnProperty('selectedMail')) ? event.selectedMail : '';
        this.selectedActivity['isScheduled'] = true;
        this.opportunityTemplateId = this.selectedActivity.opportunityTemplateId;
        var id;
        id = event.activityId;
        var selectid = [];
        selectid.push(id);
        this.activityEmail = selectid;
        var customerId = this.selectedActivity['customerDetails'].customerId;
        this.customerId = customerId;
        this.opportunityId = data.opportunityId;
        this.recordModuleId = data['recordId'] || null;
        if (activityType == 'Email' || activityType == 'Call') {
            if (this.showEmailModal == true) {
                this.confirmationBoxHelper.getConfirmation('Are you sure you want to discard the email?', this.ajsScope)
                    .then(function () {
                    _this.onModalClose('email');
                }).catch(function () { });
            }
            else {
                if (this.selectedActivity.recordType !== 'Opportunity' || (this.selectedActivity.recordType === 'Opportunity' && this.opportunityCommunicationAccess)) {
                    this.openEmailModal();
                }
            }
        }
    };
    MyScheduledActivitiesComponent.prototype.onSelectCheckbox = function (event) {
        var _this = this;
        this.showUndoMessage = true;
        setTimeout(function () {
            _this.showUndoMessage = false;
        }, 10000);
        var data = event.data;
        data.checked = event.isChecked;
        this.selectedActivity = data;
        this.scheduled = (this.selectedActivity.recordType == 'Opportunity') ? true : false;
        this.opportunityTemplateId = this.selectedActivity.opportunityTemplateId;
        this.selectedToMail = (event.hasOwnProperty('selectedMail')) ? event.selectedMail : '';
        var selectid = [];
        selectid.push(this.selectedActivity.activityId);
        this.activityEmail = selectid;
        if (this.selectedActivity['activityType'] == 'Email') {
            this.selectedActivity.checked = true;
        }
        else {
            this.selectedActivity.checked = true;
        }
        var customerId = this.selectedActivity['customerDetails'].customerId;
        this.customerId = customerId;
        this.opportunityId = data.opportunityId;
        this.recordModuleId = data['recordId'] || null;
        if (this.selectedActivity.checked) {
            if (data['activityType'] == 'Email') {
                if (this.showEmailModal == true) {
                    this.confirmationBoxHelper.getConfirmation('Are you sure you want to discard the email?', this.ajsScope)
                        .then(function () {
                        _this.onModalClose('email');
                    }).catch(function () { });
                }
                else {
                    this.completeScheduledActivity(this.selectedActivity.activityId, this.selectedActivity);
                    if (this.selectedActivity.recordType !== 'Opportunity' || (this.selectedActivity.recordType === 'Opportunity' && this.opportunityCommunicationAccess)) {
                        this.openEmailModal();
                    }
                }
            }
            else if (data['activityType'] == 'Call') {
                this.completeScheduledActivity(this.selectedActivity.activityId, this.selectedActivity);
                this.callEditData = null;
                if (this.selectedActivity.recordType !== 'Opportunity' || (this.selectedActivity.recordType === 'Opportunity' && this.opportunityCommunicationAccess)) {
                    setTimeout(function () {
                        _this.openCallModal();
                    }, 500);
                }
            }
            else if (data['activityType'] == 'Task') {
                if (this.selectedActivity.recordType == "customer" || this.selectedActivity.recordType == "job" || this.selectedActivity.recordType === 'contract') {
                    var activityData = { "activityIds": [this.selectedActivity.activityId], "screen": this.selectedActivity.recordType };
                    this.opportunityService.completeScheduledActivity(activityData).subscribe(function (data) {
                        _this.scheduledActivityListService.setRefreshActivityList(true);
                    });
                }
                else {
                    this.opportunityService.completeTask(this.selectedActivity.activityId).subscribe(function (data) {
                        _this.completeScheduledActivity(_this.selectedActivity.activityId, _this.selectedActivity);
                    });
                }
            }
            else {
                if (this.selectedActivity.recordType == "customer" || this.selectedActivity.recordType == "job" || this.selectedActivity.recordType === 'contract') {
                    var activityData = { "activityIds": [this.selectedActivity.activityId], "screen": this.selectedActivity.recordType };
                    this.opportunityService.completeScheduledActivity(activityData).subscribe(function (data) {
                        _this.scheduledActivityListService.setRefreshActivityList(true);
                    });
                }
                else {
                    this.opportunityService.completeMeeting(this.selectedActivity.activityId).subscribe(function (data) {
                        _this.completeScheduledActivity(_this.selectedActivity.activityId, _this.selectedActivity);
                    });
                }
            }
        }
    };
    MyScheduledActivitiesComponent.prototype.onModalClose = function (type, clearExistingValue) {
        if (clearExistingValue === void 0) { clearExistingValue = true; }
        this.updateModalOpenCloseStatus(type, false);
        switch (type) {
            case 'call':
                this.showCallLogModal = false;
                this.showOpportunityCallLogModal = false;
                this.callEditData = '';
                break;
            case 'activity':
                this.showActivityModal = false;
                if (clearExistingValue) {
                    this.editActivityData = '';
                }
                break;
            case 'email':
                this.showEmailModal = false;
                break;
        }
    };
    MyScheduledActivitiesComponent.prototype.updateModalOpenCloseStatus = function (type, status) {
        type = type == 'Schedule activity' ? 'activity' : type;
        var screen = (type.toLowerCase() == 'email' || type.toLowerCase() == 'activity') ? 'others' : 'customer';
        return this.sharedModalService.updateModalStatus(screen, type, status);
    };
    MyScheduledActivitiesComponent.prototype.openEmailModal = function () {
        this.todayEmailActivity = [];
        if (this.selectedActivity.recordType == "customer" || this.selectedActivity.recordType == "job" || this.selectedActivity.recordType === 'contract') {
            var type = 'Email';
            this.checkTodayActivity = true;
            this.setScreenType();
            this.validateModalStatus(type);
        }
        else {
            this.setScreenType();
            var type = 'email';
            this.validateModalStatus(type);
        }
    };
    MyScheduledActivitiesComponent.prototype.validateModalStatus = function (type) {
        var _this = this;
        var modalStatusCheck = this.sharedModalService.checkModalStatus();
        if (modalStatusCheck) {
            this.confirmationBoxHelper.getConfirmation("Are you sure you want to discard the " + modalStatusCheck + " ?", this.ajsScope)
                .then(function () {
                _this.onModalClose(modalStatusCheck, false);
                _this.selectedWidgetsType = '';
                _this.commonModalRemoval();
                if (modalStatusCheck == 'email') {
                    var emailParams = {
                        isFromJs: false,
                        showModal: false,
                    };
                    _this.sharedModalService.setEmailModalDetails(emailParams);
                }
                setTimeout(function () {
                    _this.modalSelection(type);
                }, 500);
            });
        }
        else {
            this.selectedWidgetsType = '';
            this.modalSelection(type);
        }
    };
    MyScheduledActivitiesComponent.prototype.setScreenType = function () {
        if (this.selectedActivity.recordType == "customer" || this.selectedActivity.recordType == "job" || this.selectedActivity.recordType === 'contract') {
            this.isCommonRoute = true;
            this.screenType = this.selectedActivity.recordType.toLowerCase();
            if (this.screenType == 'job') {
                this.screenType = 'jobs';
            }
            this.customerType = 'customer';
        }
        else {
            this.isCommonRoute = false;
        }
    };
    MyScheduledActivitiesComponent.prototype.completeScheduledActivity = function (activityId, activityDetails) {
        var _this = this;
        var activityData = { "activityIds": [activityId], 'screen': activityDetails.recordType };
        if (activityDetails.recordType == "customer" || activityDetails.recordType == "job" || activityDetails.recordType === 'contract') {
            this.opportunityService.completeScheduledActivity(activityData).subscribe(function (data) {
                _this.scheduledActivityListService.setRefreshActivityList(true);
                _this.showToast('Scheduled activity completed');
            });
        }
        else {
            this.opportunityService.completeScheduleActivity(activityData).subscribe(function (data) {
                _this.scheduledActivityListService.setRefreshActivityList(true);
                _this.showToast('Scheduled activity completed');
            });
        }
    };
    MyScheduledActivitiesComponent.prototype.openCallModal = function () {
        var _this = this;
        this.activityList = [];
        if (this.selectedActivity.recordType == "customer" || this.selectedActivity.recordType == "job" || this.selectedActivity.recordType === 'contract') {
            var type_1 = 'Call';
            this.setScreenType();
            var moduleId = this.screenType === 'contract' ? this.recordModuleId : this.selectedActivity.recordType == "job" ? this.selectedActivity.recordId : this.customerId;
            this.propertyService.getTodayScheduleActivity(moduleId, type_1, this.screenType).subscribe(function (data) {
                _this.activityList = data;
                _this.validateModalStatus(type_1);
            });
        }
        else if (this.opportunityCommunicationAccess) {
            this.setScreenType();
            var type = 'Call';
            this.validateModalStatus(type);
        }
    };
    MyScheduledActivitiesComponent.prototype.commonModalRemoval = function () {
        if (!this.activityEdit) {
            this.selectedWidgetsType = '';
            this.editActivityData = 'reschedule';
        }
        var params = {
            showActivityModal: false,
        };
        this.sharedModalService.setScheduledActivityDetails(params);
        var emailParams = {
            isFromJs: false,
            showModal: false,
        };
        this.sharedModalService.setEmailModalDetails(emailParams);
    };
    MyScheduledActivitiesComponent.prototype.modalSelection = function (type) {
        var _this = this;
        this.updateModalOpenCloseStatus(type, true);
        if (type.toLowerCase() == 'call') {
            this.selectedWidgetsType = 'call';
            if (this.selectedActivity.recordType === 'customer' || this.selectedActivity.recordType === 'job' || this.selectedActivity.recordType === 'contract') {
                this.showCallLogModal = true;
            }
            else if (this.selectedActivity.recordType === 'Opportunity') {
                this.showOpportunityCallLogModal = true;
            }
        }
        else if (type.toLowerCase() == 'activity') {
            this.openScheduleModal();
        }
        else if (type.toLowerCase() == 'email') {
            setTimeout(function () {
                _this.triggerEmailModal();
            }, 300);
        }
    };
    MyScheduledActivitiesComponent.prototype.openScheduleModal = function () {
        this.screenType = this.selectedActivity.recordType;
        if (this.screenType == 'job') {
            this.screenType = 'jobs';
        }
        this.recordBasedAssigneeList = this.assigneeList;
        var params = this.getScheduledActivityParams();
        this.sharedModalService.setScheduledActivityDetails(params);
    };
    MyScheduledActivitiesComponent.prototype.triggerEmailModal = function () {
        this.screenType = this.selectedActivity.recordType;
        if (this.screenType == 'job') {
            this.screenType = 'jobs';
        }
        this.recordBasedAssigneeList = this.assigneeList;
        this.scheduledActivityParams = {
            tablePkId: this.screenType === 'contract' ? this.recordModuleId : this.selectedActivity.recordType == "job" ? this.selectedActivity.recordId : this.customerId,
            screenType: this.screenType,
            isCommonRoute: this.isCommonRoute,
            showActivityModal: true,
            listActivity: this.listActivity,
            assigneeList: this.recordBasedAssigneeList,
            scheduledData: "reschedule",
            opportunityId: this.opportunityId
        };
        var customerType = (this.screenType != 'Opportunity') ? 2 : 232;
        if (this.screenType == 'jobs') {
            customerType = 31;
        }
        var contractTableTypeConstant = 301;
        if (this.screenType == 'Opportunity') {
            var opportunityAttachmentQuery = {
                limit: 1000,
                page: 1,
                opportunityId: this.opportunityId,
                newEmailModal: true
            };
        }
        else {
            var attachmentQuery = {
                tableType: customerType,
                id: this.customerId,
            };
        }
        var customerQuery = {
            id: this.customerId,
            type: 'all_email',
        };
        var relatedObjectId = {
            customer: this.customerId,
            contract: this.recordModuleId,
            Opportunity: this.opportunityId,
            job: this.selectedActivity.recordId,
            jobs: this.selectedActivity.recordId
        };
        var params = {
            attachments_url: (this.screenType != 'Opportunity') ? ('get_attached_files_list?' + this.sharedModalService.mapQueryParams(attachmentQuery)) : ('getAttatchedFiles/' + this.opportunityTemplateId + '?' + this.sharedModalService.mapQueryParams(opportunityAttachmentQuery)),
            from_addresses_url: '/get_from_emails',
            isFromJs: false,
            showModal: true,
            relatedObjectType: (this.screenType === 'contract') ? contractTableTypeConstant : customerType,
            relatedObjectId: relatedObjectId[this.screenType],
            screenType: this.screenType.toLowerCase(),
            customerId: this.customerId,
            scheduledActivityParams: this.scheduledActivityParams,
            todayEmailActivity: this.todayEmailActivity,
            recipient_addresses_url: 'get_customer_emailaddresses?' + this.sharedModalService.mapQueryParams(customerQuery),
            selectedToEmail: this.selectedToMail,
            completeTodayActivity: true
        };
        this.sharedModalService.setEmailModalDetails(params);
    };
    MyScheduledActivitiesComponent.prototype.showToast = function (msg) {
        this.toast.show(msg, 1500);
    };
    MyScheduledActivitiesComponent.prototype.getScheduledActivityParams = function () {
        var params = {
            isCommonRoute: this.isCommonRoute,
            showActivityModal: true,
            listActivity: this.listActivity,
            assigneeList: this.recordBasedAssigneeList,
            scheduledData: this.editActivityData,
            tablePkId: this.screenType === 'contract' ? this.recordModuleId : this.selectedActivity.recordType == "job" ? this.selectedActivity.recordId : this.customerId,
            screenType: this.screenType,
            opportunityId: this.opportunityId
        };
        return params;
    };
    MyScheduledActivitiesComponent.prototype.onCallLogSave = function (event) {
        var _this = this;
        this.updateModalOpenCloseStatus('call', false);
        if (this.selectedActivity.recordType == "customer" || this.selectedActivity.recordType == "job" || this.selectedActivity.recordType === 'contract') {
            var isScheduled_1 = event.isScheduled;
            var activityIds_1 = [];
            var moduleId = this.selectedActivity.recordType === 'contract' ? this.recordModuleId : this.selectedActivity.recordType == "job" ? this.selectedActivity.recordId : this.customerId;
            if (event.hasOwnProperty('activityIds') && event.activityIds.length) {
                if (this.selectedActivity.recordType === 'contract' || this.selectedActivity.recordType === 'job' || this.selectedActivity.recordType === 'customer') {
                    activityIds_1 = event.activityIds;
                }
                else {
                    event.activityIds.forEach(function (val, key) {
                        activityIds_1.push(val.activityId);
                    });
                }
                var activityData = { "activityIds": activityIds_1, 'screen': this.selectedActivity.recordType };
                this.opportunityService.completeScheduledActivity(activityData).subscribe(function (data) {
                    _this.showToast('Call log added and today call log activity is completed');
                }, function (error) {
                    console.error('error', error);
                });
            }
            var callLogData = new FormData;
            callLogData.append('communication[tablepkid]', moduleId);
            callLogData.append('communication[phonecall][calltype]', event.callType);
            callLogData.append('communication[phonecall][contacttelephoneid]', event.contactTelephoneId);
            callLogData.append('communication[phonecall][note]', event.note);
            if (this.selectedActivity.recordType === 'contract') {
                this._api.saveCallLog(this.customerType, this.customerId, this.selectedActivity.recordType, moduleId, callLogData).subscribe(function (data) {
                    if (data) {
                        if (isScheduled_1) {
                            _this.opportunityService.setNewReschedule(isScheduled_1);
                        }
                        _this.onModalClose('call');
                    }
                });
            }
            else {
                this.propertyService.saveCallLog(this.customerId, this.customerType, this.customerId, this.screenType, callLogData).subscribe(function (data) {
                    if (data) {
                        if (isScheduled_1) {
                            _this.opportunityService.setNewReschedule(isScheduled_1);
                        }
                        _this.onModalClose('call');
                    }
                });
            }
        }
        else {
            if (event == true) {
                this.opportunityService.setNewReschedule(event);
            }
        }
        this.opportunityService.loadActivityList(true);
    };
    MyScheduledActivitiesComponent.prototype.ngOnDestroy = function () {
        var _this = this;
        Object.keys(this.subscriptions).forEach(function (subscription) { return _this.subscriptions[subscription].unsubscribe(); });
    };
    MyScheduledActivitiesComponent.prototype.undoCompleted = function () {
        var _this = this;
        this.showUndoMessage = false;
        this.setScreenType();
        var activityData = { "activityIds": [this.selectedActivity.activityId] };
        var _a = this.selectedActivity, teamMembersConfig = _a.teamMembersConfig, plainActivity = tslib_1.__rest(_a, ["teamMembersConfig"]);
        var record = JSON.parse(JSON.stringify(plainActivity));
        record['activityCompleted'] = false;
        record['checked'] = false;
        if (!this.isCommonRoute) {
            this.opportunityService.undoScheduleActivity(activityData).subscribe(function (data) {
                _this.opportunityService.setRefreshActivityList(true);
                _this.selectedActivity.status = 'Pending';
                _this.opportunityService.setCompleteActivityDetails(record);
                if (data['opportunityStatus'] != '') {
                    _this.opportunityService.setOpportunityStatus(data['opportunityStatus']);
                }
                _this.onTabSelect('first');
            }, function (error) {
                console.error('error', error);
            });
        }
        else {
            activityData.undo = true;
            this.opportunityService.completeScheduledActivity(activityData).subscribe(function (data) {
                _this.opportunityService.setRefreshActivityList(true);
                _this.selectedActivity.status = 'Completed';
                record.undo = true;
                _this.opportunityService.setCompleteActivityDetails(record);
                _this.propertyService.setRefreshSliderScheduleActivity(true);
                _this._alEvent.notifyScheduledActivityCompletion(record);
                _this.onTabSelect('first');
            }, function (error) {
                console.error('error', error);
            });
        }
    };
    MyScheduledActivitiesComponent.prototype.onSearch = function () {
        // Still composing a "#tag" mention (dropdown open) - don't run a real free-text search on it.
        if (/#\w*$/.test(this.param.searchText)) {
            return;
        }
        if ((this.param.searchText != '' && this.param.searchText.length > 1) || (this.oldSearchValue.length > 1 && this.oldSearchValue != '' && this.param.searchText == '')) {
            this.oldSearchValue = this.param.searchText;
            this.onTabSelect('first');
        }
    };
    MyScheduledActivitiesComponent.prototype.onCloseModal = function () {
        this.onClose.emit(false);
    };
    MyScheduledActivitiesComponent.prototype.clearSearch = function () {
        this.param.searchText = '';
        this.showTagDropdown = false;
        this.onSearch();
    };
    /** Detects "#word" being typed in the search box and opens a filtered tag dropdown (mirrors the
     * "@" user-mention pattern used on the Jobs page search bar). */
    MyScheduledActivitiesComponent.prototype.onSearchInput = function (event) {
        var _this = this;
        var text = event.target.value || '';
        var hashIndex = text.lastIndexOf('#');
        if (hashIndex === -1) {
            this.showTagDropdown = false;
            return;
        }
        var match = text.match(/#(\w*)/);
        var term = (match ? match[1] : '').toLowerCase();
        if (!this.hashtagsLoaded) {
            this.hashtagsLoaded = true;
            this.sharedModalService.getHashTagsList().subscribe(function (response) {
                _this.hashtags = response.hashtags || [];
                _this.updateFilteredTagDropdown(term);
            });
        }
        else {
            this.updateFilteredTagDropdown(term);
        }
    };
    MyScheduledActivitiesComponent.prototype.updateFilteredTagDropdown = function (term) {
        var _this = this;
        this.filteredTags = this.hashtags.filter(function (tag) {
            return tag.description.toLowerCase().includes(term) &&
                !_this.selectedTagFilters.find(function (t) { return t.id == tag.id; });
        });
        this.showTagDropdown = this.filteredTags.length > 0;
    };
    MyScheduledActivitiesComponent.prototype.selectTagFilter = function (tag) {
        if (!this.selectedTagFilters.find(function (t) { return t.id == tag.id; })) {
            this.selectedTagFilters.push(tag);
        }
        this.param.searchText = this.param.searchText.replace(/#(\w*)$/, '');
        this.showTagDropdown = false;
        this.onTabSelect('first');
    };
    MyScheduledActivitiesComponent.prototype.removeTagFilter = function (tag) {
        this.selectedTagFilters = this.selectedTagFilters.filter(function (t) { return t.id != tag.id; });
        this.onTabSelect('first');
    };
    MyScheduledActivitiesComponent.prototype.onTagSelected = function (tag, activity) {
        this.activities.map(function (activite) {
            if (String(activite.activityId) === String(activity.activityId)) {
                return tslib_1.__assign({}, activite, { tagsList: activite.tagsList.concat([tag]) });
            }
            return activite;
        });
        var tagValue = [];
        tagValue.push(tag.description);
        var data = { activityId: activity.activityId, tags: tagValue };
        this.sharedModalService.saveActivityTag(data).subscribe(function (data) {
        });
    };
    MyScheduledActivitiesComponent.prototype.onTagRemoved = function (tag, activity) {
        this.activities = this.activities.map(function (activite) {
            if (String(activite.activityId) === String(activity.activityId)) {
                return tslib_1.__assign({}, activite, { tagsList: activite.tagsList.filter(function (t) { return t.id != tag.id; }) });
            }
            return activite;
        });
        var tagValue = [];
        tagValue.push(tag.id);
        var data = { activityId: activity.activityId, tagId: tagValue };
        this.sharedModalService.removeActivityTag(data).subscribe(function (data) {
        });
    };
    return MyScheduledActivitiesComponent;
}());
export { MyScheduledActivitiesComponent };
